<template>
    <section v-if="headline && text">
        <div class="container">
            <div class="message">
                <p>
                    {{ headline }}
                </p>
                <div v-html="text">

                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'model-details-info-box',
        props: {
            headline: {
                type: String,
                default: undefined
            },
            text: {
                type: String,
                default: undefined
            }
        },
        data() {
            return {

            }
        }
    }
</script>